import React, { PureComponent } from 'react'
import 'react-dates/initialize'
import DayPickerRangeController from 'react-dates/lib/components/DayPickerRangeController'
import { connect } from 'react-redux'

import i18next from 'i18next'
import moment from 'moment'
import PropTypes from 'prop-types'

import i18n from '~/i18n'

import DatePresets from '../datepicker/Presets'
// import 'moment/locale/pt-br'
// import 'moment/locale/es'
// import 'moment/locale/en-sg'

const language = i18n.language || 'pt-BR'
moment.locale(language)

export class Calendar extends PureComponent {
  constructor(_props) {
    super(_props)
    this.state = {
      focusedInput: 'startDate'
    }

    this.changeDate = this.changeDate.bind(this)
    this.isOutsideRange = this.isOutsideRange.bind(this)
    this.outsideClick = this.outsideClick.bind(this)
  }

  static defaultProps = {
    onChange: () => {},
    label: i18next.t('common:words.date'),
    align: 'left',
    monthsToShow: 2,
    range: 48,
    initialMonth: moment().subtract(1, 'month'),
    disabled: false,
    isMobile: false,
    isRangeDate: false,
    isOutsideRange: () => false
  }

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    defaultStartDate: PropTypes.instanceOf(moment),
    defaultEndDate: PropTypes.instanceOf(moment),
    defaultSingleDate: PropTypes.instanceOf(moment),
    label: PropTypes.string,
    align: PropTypes.oneOf(['left', 'right']),
    monthsToShow: PropTypes.number,
    initialMonth: PropTypes.instanceOf(moment),
    isMobile: PropTypes.bool,
    locale: PropTypes.string,
    isRangeDate: PropTypes.bool,
    hidePresets: PropTypes.bool,
    maxSpanDays: PropTypes.number,
    startDate: PropTypes.instanceOf(moment),
    range: PropTypes.number,
    isOutsideRange: PropTypes.func,
    presets: PropTypes.array,
    selectionStart: PropTypes.string,
    selectionEnd: PropTypes.string
  }

  changeDate({ startDate, endDate, isPreset = false }) {
    const newState = {}

    let dateValues = {
      startDate,
      endDate: null
    }

    if ((this.state.focusedInput === 'endDate' || isPreset) && endDate) {
      dateValues.endDate = endDate
      newState.focusedInput = 'startDate'
    }

    if (!this.props.isRangeDate) {
      dateValues = {
        date: startDate
      }
      newState.focusedInput = 'startDate'
    }

    this.props.onChange(dateValues)

    this.setState({ ...newState })
  }

  isOutsideRange(day) {
    const { range, startDate, maxSpanDays } = this.props
    const { focusedInput } = this.state

    if (focusedInput !== 'endDate' || !startDate) {
      return this.props.isOutsideRange(day)
    }

    if (maxSpanDays != null) {
      const lastValidEnd = moment(startDate)
        .clone()
        .startOf('day')
        .add(maxSpanDays - 1, 'days')
      return (
        day.clone().startOf('day').isAfter(lastValidEnd, 'day') ||
        this.props.isOutsideRange(day)
      )
    }

    return (
      day.isAfter(moment(startDate).add(range, 'months')) ||
      this.props.isOutsideRange(day)
    )
  }

  outsideClick() {
    const { startDate, endDate, isRangeDate } = this.props
    let resetDates = {}

    if (!startDate && isRangeDate) {
      resetDates = { startDate: null, endDate: null }
    } else if (!endDate && isRangeDate) {
      resetDates = { startDate, endDate: startDate }
    }
    this.setState({ focusedInput: 'startDate' })
    this.props.onChange(resetDates)
    this.props.onOutsideClick()
  }

  //

  render() {
    const {
      monthsToShow,
      isMobile,
      onOutsideClick,
      startDate,
      endDate,
      date,
      initialMonth,
      hidePresets = false,
      // maxSpanDays is consumed in isOutsideRange; must not be forwarded to DayPicker
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      maxSpanDays,
      presets: presetsOverride,
      selectionStart,
      selectionEnd,
      ...rest
    } = this.props

    return (
      <DayPickerRangeController
        startDate={startDate || date}
        endDate={endDate}
        onDatesChange={({ startDate, endDate }) => {
          this.changeDate({ startDate, endDate })
        }}
        displayFormat={i18next.t('common:patterns.date')}
        focusedInput={this.state.focusedInput}
        onFocusChange={focusedInput => this.setState({ focusedInput })}
        hideKeyboardShortcutsPanel
        numberOfMonths={isMobile ? 1 : monthsToShow}
        isOutsideRange={this.isOutsideRange}
        onOutsideClick={onOutsideClick && this.outsideClick}
        minimumNights={0}
        initialVisibleMonth={() => initialMonth}
        renderCalendarInfo={() =>
          hidePresets ? null : (
            <DatePresets
              handlePresets={(start, end) => {
                this.changeDate({
                  startDate: start,
                  endDate: end,
                  isPreset: true
                })
              }}
              presets={presetsOverride}
              selectionStart={selectionStart}
              selectionEnd={selectionEnd}
            />
          )
        }
        {...rest}
      />
    )
  }
}

export default connect(
  state => ({
    isMobile: state.layout.isMobile
  }),
  {}
)(Calendar)
